<template>
  <div class="content-page" v-loading="isLoad">
    <div class="right-container">
      <div class="contact-service container" v-show="isOwn">
        <div class="content-container">
          <img class="icon" src="@/assets/img/home/icon-contact-service.png" alt />
          <div class="info">
            <p class="title">联系客服</p>
            <p class="desc">电话：0577-86661188</p>
          </div>
        </div>
      </div>
      <div
        class="download container"
        @click="showDownloadQrcod = true"
        v-show="isOwn && shop.edcShopType != 5"
      >
        <div class="content-container">
          <img class="icon" src="@/assets/img/home/icon-download.png" alt />
          <div class="info">
            <p class="title">码点餐平板客户端</p>
            <p class="desc">客户可使用平板点餐</p>
          </div>
        </div>
      </div>
      <div class="message container" v-show="shop.edcShopType != 5">
        <div class="top">
          <p class="title">
            近期消息
            <el-link :underline="false" type="primary" @click="linkTo('/message')"
              >更多</el-link
            >
          </p>
        </div>
        <div class="content-container">
          <div class="message-list">
            <div class="item" v-for="(item, index) in messageList" :key="index">
              <el-link
                :type="item.isRead ? 'info' : 'danger'"
                class="item-title"
                :underline="false"
                @click="linkTo(`/message/info?newsId=${item.newsId}`)"
                >{{ item.newsTitle }}</el-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="left-container">
      <div class="status-contanier" v-if="shop.edcShopType != 5">
        <div class="shop-status container">
          <div class="top clearfix">
            <div class="left">
              <span class="title">店铺状态</span>
            </div>
            <div class="right">
              <el-link :underline="false" type="primary" @click="linkTo('/setting')"
                >店铺设置</el-link
              >
            </div>
          </div>
          <div class="content-container">
            <div class="shop-info clearfix">
              <img class="avatar" :src="shop.shopLogo" alt />
              <div class="info">
                <p class="shop-name">
                  {{ shop.shopName }}
                  <el-tag :type="shop.isVerified ? 'success' : 'danger'">{{
                    shop.isVerified ? "已认证" : "未认证"
                  }}</el-tag>
                </p>
                <p class="shop-time">营业时间：{{ shop.businessHours }}</p>
              </div>
            </div>
            <div class="marketing-info">
              <span class="info-of-num">
                开通服务：
                <span class="num">{{ funcNum }}</span
                >个
              </span>
              <div v-if="isOwn">
                <el-link
                  :underline="false"
                  type="primary"
                  @click="linkTo('/marketing/myorder')"
                  >查看详情</el-link
                >
                <span class="info-tips"
                  >（小提示：开通点餐、和外卖可以为您带来更多的订单哦~）</span
                >
              </div>
            </div>
            <div class="fuc-info">
              <div class="func-container">
                <div>
                  <span class="status" :class="takeoutStatus ? 'open' : 'close'"
                    >外卖({{ takeoutStatus ? "已开启" : "已关闭" }})</span
                  >
                  <el-switch
                    v-model="takeoutStatus"
                    @change="modifyTakeoutStatus"
                    active-color="#67c23a"
                    inactive-color="#f57878"
                  ></el-switch>
                </div>
                <span class="info-of-num">
                  待处理订单：
                  <span class="num">{{ takeoutToDoOrderNum }}</span
                  >个
                </span>
              </div>
              <div class="func-container">
                <div>
                  <span class="status" :class="tangStatus ? 'open' : 'close'"
                    >堂食({{ tangStatus ? "已开启" : "已关闭" }})</span
                  >
                  <el-switch
                    v-model="tangStatus"
                    @change="modifyTakeoutStatus"
                    active-color="#67c23a"
                    inactive-color="#f57878"
                  ></el-switch>
                </div>
                <span class="info-of-num">
                  待处理订单：
                  <span class="num">{{ tangToDoOrderNum }}</span
                  >个
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="table-status container">
          <div class="top clearfix">
            <div class="left">
              <span class="title">桌位状态</span>
              <el-radio-group v-model="tableStatus" size="mini">
                <el-radio :label="5">全部</el-radio>
                <el-radio :label="1">占用</el-radio>
                <el-radio :label="3">已结账</el-radio>
                <el-radio :label="0">空闲</el-radio>
              </el-radio-group>
            </div>
            <div class="right">
              <span> <i class="circle color-b"></i>占用 </span>
              <span> <i class="circle color-y"></i>已结账 </span>
              <span> <i class="circle"></i>空闲 </span>
            </div>
          </div>
          <div class="content-container">
            <el-tabs v-model="regionActive" type="card">
              <el-tab-pane
                v-for="(item, index) in regionList"
                :key="String(item.shopAreaId)"
                :label="item.areaName"
                :name="String(index)"
              ></el-tab-pane>
            </el-tabs>
            <div class="table-list" v-loading="isTableListLoad">
              <el-tooltip
                placement="bottom"
                effect="light"
                v-for="(item, index) in tableList"
                :key="index"
                :disabled="item.status == 0 ? true : false"
              >
                <div slot="content">
                  <strong>{{ item.tableConfigName }}</strong>
                  <br />
                  <span v-if="item.peopleNum">{{ item.peopleNum }}人正在用餐</span>
                </div>
                <div
                  class="item"
                  :class="
                    item.status == 1 || item.status == 2
                      ? 'occupy'
                      : item.status == 3
                      ? 'printed'
                      : ''
                  "
                  @click="linkTo(`/order?shoppingTableId=${item.shoppingTableId}`)"
                >
                  <!-- linkTo(
                      `/home/order?shopId=${shop.shopId}&shoppingTableId=${
                        item.shoppingTableId
                      }&tableName=${item.tableName}`
                    ) -->
                  {{ item.tableName }}
                  <div class="btn" @click.stop="clearTable(item.shoppingTableId)">
                    清空
                  </div>
                  <div class="queue-tag" v-if="item.appointments.length">已预定</div>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="real-time-overview container">
        <div class="top clearfix">
          <div class="left">
            <span class="title">实时概况</span>
          </div>
          <div class="right">
            <p class="data-info">
              更新时间：{{ updateTime }}
              <el-link :underline="false" type="primary" @click="linkTo('/data')"
                >更多数据</el-link
              >
            </p>
          </div>
        </div>
        <div class="content-container">
          <div class="row">
            <div class="item">
              <div class="icon circle blue">
                <i class="iconfont iconjine"></i>
              </div>
              <div class="info">
                <p class="title">今日营业额（元）</p>
                <strong class="num">{{ todayMoney }}</strong>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <i class="iconfont iconjine"></i>
              </div>
              <div class="info">
                <p class="title">累计营业额（元）</p>
                <strong class="num">{{ totalMoney }}</strong>
              </div>
            </div>
            <div class="item">
              <div class="icon circle red">
                <i class="iconfont iconiconfontgerenzhongxin"></i>
              </div>
              <div class="info">
                <p class="title">今日新增会员</p>
                <strong class="num">{{ todayMember }}</strong>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <i class="iconfont iconiconfontgerenzhongxin"></i>
              </div>
              <div class="info">
                <p class="title">累计会员人数</p>
                <strong class="num">{{ allMember }}</strong>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <div class="icon circle green">
                <i class="iconfont icondingdan"></i>
              </div>
              <div class="info">
                <p class="title">今日订单量（笔）</p>
                <strong class="num">{{ todayOrderNum }}</strong>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <i class="iconfont icondingdan"></i>
              </div>
              <div class="info">
                <p class="title">累计订单量（笔）</p>
                <strong class="num">{{ totalOrderNum }}</strong>
              </div>
            </div>
            <div class="item" v-if="shop.edcShopType != 5">
              <div class="icon circle yellow">
                <i class="iconfont icon-dianzan"></i>
              </div>
              <div class="info">
                <p class="title">未回复评论</p>
                <strong class="num">{{ unCommentNum }}</strong>
              </div>
            </div>
            <div class="item" v-if="shop.edcShopType != 5">
              <div class="icon">
                <i class="iconfont icon-dianzan"></i>
              </div>
              <div class="info">
                <p class="title">
                  未处理差评
                  <el-link
                    :underline="false"
                    type="primary"
                    @click="linkTo('/comment?shopScore')"
                    >去处理差评</el-link
                  >
                </p>
                <strong class="num">{{ badCommentNum }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vegetable-sales container" v-if="shop.edcShopType != 5">
        <div class="top clearfix">
          <div class="left">
            <span class="title">销量排名</span>
          </div>
          <div class="right">
            <p class="data-info">
              更新时间：{{ updateTime }}
              <el-link :underline="false" type="primary" @click="linkTo('/data/goods')"
                >更多数据</el-link
              >
            </p>
          </div>
        </div>
        <div class="content-container">
          <div class="goods-list">
            <div class="item" v-for="(item, index) in top5GoodsList" :key="index">
              <img class="pic" :src="item.goodsImage" alt />
              <div class="info">
                <p class="title">{{ item.goodsName }}</p>
                <p class="num">累计销量：{{ item.monthlySales || "0" }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="common-func container" v-if="isOwn && shop.edcShopType != 5">
        <div class="top clearfix">
          <div class="left">
            <span class="title">常用功能</span>
          </div>
        </div>
        <div class="content-container">
          <div class="list">
            <div
              class="item"
              v-for="(item, index) in commonFucList"
              :key="index"
              @click="linkTo(item.path)"
            >
              <div class="icon rect" :class="item.iconColor">
                <i class="iconfont" :class="item.icon"></i>
              </div>
              <div class="info">
                <p class="title">
                  {{ item.title }}
                  <span v-if="item.isShowNum">
                    （
                    <span class="num">{{
                      ~item.path.indexOf("/comment")
                        ? unCommentNum
                        : ~item.path.indexOf("/order")
                        ? toDoOrderNum
                        : 0
                    }}</span>
                    ）
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="marketing-apply container" v-show="isOwn">
        <div class="top clearfix">
          <div class="left">
            <span class="title">营销应用</span>
          </div>
        </div>
        <div class="content-container">
          <div class="product-list">
            <div
              class="item"
              v-for="productItem in productList"
              :key="productItem.name"
              @click="
                linkToProductInfo(
                  productItem.userFuncType
                    ? productItem.userFuncType
                    : productItem.linkurl,
                  productItem.userFuncType ? 'type' : 'url'
                )
              "
            >
              <img :src="productItem.img" alt />
              <div class="info">
                <p class="title">{{ productItem.name }}</p>
                <p class="desc">{{ productItem.content }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      class="verified-dialog"
      width="300px"
      :visible.sync="showVerifiedTips"
    >
      <div class="dialog-content">
        <img class="icon" src="@/assets/img/home/icon-verified.png" alt />
        <p class="title">商家认证</p>
        <p class="tips">商户认证后，可开启线上支付 让用户购物更加便捷！</p>
        <el-link type="primary" class="close-tips" @click="closeTips">不再提示</el-link>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showVerifiedTips = false">跳过</el-button>
        <el-button type="primary" @click="linkTo('/setting/certification')"
          >去认证</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      class="download-dialog"
      width="400px"
      :visible.sync="showDownloadQrcod"
    >
      <div slot="title" class="dialog-title">扫码下载</div>
      <div class="dialog-content">
        <el-radio-group
          v-model="downloadTab"
          @change="changeTab"
          style="margin-bottom: 30px"
        >
          <el-radio-button label="IOS">苹果ipad</el-radio-button>
          <el-radio-button label="Android">Android点餐机</el-radio-button>
        </el-radio-group>
        <div v-if="downloadTab == 'IOS'">
          <qrcode
            :value="downloadUrl"
            :options="{ size: 200 }"
            class="scan-code-img"
          ></qrcode>
        </div>
        <p>
          {{
            downloadTab == "IOS"
              ? "请使用ipad扫码下载"
              : "Android点餐机请到商米应用市场搜索‘码点餐’下载安装"
          }}
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getShopInfo,
  getShopAreas,
  getShopTables,
  getStatisticsOrders,
  getStatisticsOrdersToday,
  getStatisticsCommentNum,
  getMemberStatistic,
  getFindTop5Goods,
  getOrderNumsByStatus,
  clearTable,
  getFuncList,
  getShopNotices,
  setTableEmpty,
  modifyShopInfo,
} from "@/api/index.js";
import qrcode from "@xkeshi/vue-qrcode";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      isLoad: true,
      isTableListLoad: true,
      tableStatus: 5,
      shopTableStatus: "",
      takeoutStatus: false,
      tangStatus: false,
      regionActive: "0",
      regionList: [],
      tableList: [],
      totalMoney: 0,
      totalOrderNum: 0,
      todayMoney: 0,
      todayOrderNum: 0,
      unCommentNum: 0,
      badCommentNum: 0,
      allMember: 0,
      todayMember: 0,
      top5GoodsList: [],
      updateTime: "",
      commonFucList: [
        {
          title: "新建商品",
          icon: "icon-dianzan",
          iconColor: "blue",
          path: "/goods/edit",
          isShowNum: false,
        },
        {
          title: "新建会员",
          icon: "iconiconfontgerenzhongxin",
          iconColor: "green",
          path: "/vip?type=addvip",
          isShowNum: false,
        },
        {
          title: "开通点餐",
          icon: "iconhuiyuan",
          iconColor: "yellow",
          path: "/marketing/order?userFuncType=2",
          isShowNum: false,
        },
        {
          title: "添加桌位",
          icon: "icon-dianzan",
          iconColor: "red",
          path: "/table?type=addtable",
          isShowNum: false,
        },
        {
          title: "待回复评论",
          icon: "icon-dianzan",
          iconColor: "blue",
          path: "/comment?replyStatus",
          isShowNum: true,
        },
        {
          title: "待处理订单",
          icon: "icondingdan",
          iconColor: "blue",
          path: "/order",
          isShowNum: true,
        },
      ],
      takeoutToDoOrderNum: 0,
      tangToDoOrderNum: 0,
      toDoOrderNum: 0,
      funcNum: 0,
      showVerifiedTips: false,
      showDownloadQrcod: false,
      downloadTab: "IOS",
      downloadUrl: "https://itunes.apple.com/cn/app/id1464124039?mt=8",
    };
  },
  components: {
    qrcode,
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
      productList: (state) => state.productsList[1].list,
      messageList: (state) => state.messageList,
      isOwn: (state) => state.isOwn,
    }),
  },
  watch: {
    regionActive(value) {
      this.isTableListLoad = true;
      this.getShopTables();
    },
    tableStatus(val) {
      this.isTableListLoad = true;
      this.shopTableStatus = val == 5 ? "" : val;
      this.getShopTables();
    },
  },
  mounted() {
    this.getHomeData();
    let url = window.location.href;
  },
  methods: {
    ...mapActions(["updateShopInfo", "updateMessage"]),
    changeTab(e) {
      console.log(e);
      if (e == "IOS") {
        this.downloadUrl = "https://itunes.apple.com/cn/app/id1464124039?mt=8";
      }
      if (e == "Android") {
        this.downloadUrl = "https://itunes.apple.com/cn/app/id1464124039?mt=81";
      }
    },
    linkTo(path) {
      if (path == "/comment?replyStatus") {
        this.$router.push({
          name: "comment",
          params: {
            replyStatus: "0",
          },
        });
        return;
      }
      if (path == "/comment?shopScore") {
        this.$router.push({
          name: "comment",
          params: {
            shopScore: "1",
          },
        });
        return;
      }
      this.$router.push({
        path,
      });
    },
    linkToProductInfo(url, type) {
      if (type == "url") {
        window.open(url);
      } else {
        this.$router.push({
          path: "/marketing/order",
          query: {
            userFuncType: url,
          },
        });
      }
    },
    async getHomeData() {
      this.takeoutStatus = ~this.shop.edcfuncTags.indexOf("1") ? true : false;
      this.tangStatus = ~this.shop.edcfuncTags.indexOf("2") ? true : false;
      if (this.shop.isVerified == 0 && !localStorage.closeTips) {
        this.showVerifiedTips = true;
      }
      await getShopNotices().then((res) => {
        if (res.code == 1) {
          this.updateMessage(res.data);
        }
      });
      getShopAreas({
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          res.data.unshift({
            areaName: "全部",
            shopAreaId: "",
            shopId: "",
          });
          this.regionList = res.data;
        } else {
          this.regionList = [
            {
              areaName: "全部",
              shopAreaId: "",
              shopId: "",
            },
          ];
          this.isTableListLoad = false;
        }
        this.getShopTables();
      });
      getStatisticsOrders().then((res) => {
        if (res.code == 1) {
          this.totalMoney = res.data.money ? res.data.money : 0;
          this.totalOrderNum = res.data.orderNum ? res.data.orderNum : 0;
        }
      });
      getStatisticsOrdersToday().then((res) => {
        if (res.code == 1) {
          console.log(res, "getStatisticsOrdersToday");
          this.todayMoney = res.data.money ? res.data.money : 0;
          this.todayOrderNum = res.data.orderNum ? res.data.orderNum : 0;
        } else {
          this.todayMoney = 0;
          this.todayOrderNum = 0;
        }
      });
      getStatisticsCommentNum({
        replyStatus: 0,
      }).then((res) => {
        if (res.code == 1) {
          this.unCommentNum = res.data.commentNum;
          this.badCommentNum = res.data.badCommentNum;
        }
      });
      getMemberStatistic().then((res) => {
        if (res.code == 1) {
          this.allMember = res.data.all_member;
          this.todayMember = res.data.today_member;
        }
      });
      getFindTop5Goods().then((res) => {
        if (res.code == 1) {
          this.top5GoodsList = res.data;
        }
      });
      getOrderNumsByStatus({
        orderCategory: 3,
        unhandle: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.takeoutToDoOrderNum = res.data[0].orderNum;
          this.toDoOrderNum += res.data[0].orderNum;
        }
      });
      getOrderNumsByStatus({
        orderCategory: 5,
        unhandle: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.tangToDoOrderNum = res.data[0].orderNum;
          this.toDoOrderNum += res.data[0].orderNum;
        }
      });
      getFuncList().then((res) => {
        if (res.code == 1) {
          this.funcNum = res.data.length;
        }
      });
      this.updateTime = new Date().pattern("yyyy-MM-dd HH:mm:ss");
      this.isLoad = false;
    },
    getShopTables() {
      getShopTables({
        shopAreaId: this.regionList[this.regionActive].shopAreaId,
        status: this.shopTableStatus,
        row: 1000,
      }).then((tablesRes) => {
        if (tablesRes.code == 1) {
          this.tableList = tablesRes.data;
          this.isTableListLoad = false;
        } else {
          this.tableList = [];
          this.isTableListLoad = false;
        }
      });
    },
    clearTable(id) {
      setTableEmpty({
        shoppingTableId: id,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "桌位已清空",
            type: "success",
            duration: 6000,
          });
          this.getShopTables();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 6000,
          });
        }
      });
    },
    closeTips() {
      this.showVerifiedTips = false;
      localStorage.closeTips = true;
    },
    modifyTakeoutStatus() {
      let params = JSON.parse(JSON.stringify(this.shop));
      params.edcfuncTags = this.takeoutStatus ? "1," : "";
      params.edcfuncTags += this.tangStatus ? "2" : "";
      modifyShopInfo(params).then((res) => {
        if (res.code == 1) {
          getShopInfo().then((shopInfo) => {
            this.updateShopInfo(shopInfo.data);
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  background: #f1f1f1;
  padding: 20px;
  box-sizing: border-box;
  .container {
    background: #fff;
    margin-bottom: 20px;
    padding: 20px;
    cursor: default;
  }
  .circle {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1px solid #eff0f3;
    background: #fff;
    box-sizing: border-box;
    vertical-align: bottom;
    margin-right: 6px;
    margin-left: 20px;
  }
  .color-b {
    background: #409eff;
    border-color: #409eff;
  }
  .color-y {
    background: #ffa51e;
    border-color: #ffa51e;
  }
  .left-container {
    padding-right: 260px;
    & > .container {
      min-width: 930px;
    }
    .container {
      .top {
        font-size: 16px;
        line-height: 16px;
        margin-bottom: 20px;
        .left {
          float: left;
          .title {
            color: #333333;
            font-weight: bold;
          }
        }
        .right {
          float: right;
          font-size: 14px;
          .data-info {
            font-size: 12px;
            color: #999999;
            .el-link {
              margin-left: 10px;
              font-size: 12px;
              vertical-align: inherit;
            }
          }
        }
      }
      .icon {
        text-align: center;
        color: #fff;
        .iconfont {
          font-size: 22px;
        }
        &.circle {
          width: 45px;
          height: 45px;
          line-height: 43px;
          border-radius: 50%;
          &.iconfont {
            font-size: 22px;
          }
        }
        &.rect {
          width: 20px;
          height: 20px;
          line-height: 20px;
          border-radius: 4px;
          &.iconfont {
            font-size: 12px;
          }
        }
        &.blue {
          background: #409eff;
        }
        &.red {
          background: #f56c6c;
        }
        &.green {
          background: #67c23a;
        }
        &.yellow {
          background: #ffa51e;
        }
      }
    }
    .status-contanier {
      min-width: 970px;
      display: flex;
      .shop-status {
        flex: 0.43;
        margin-right: 20px;
        .info-of-num {
          font-size: 12px;
          line-height: 12px;
          color: #666666;
          .num {
            font-size: 14px;
            font-weight: bold;
            color: #ff4343;
          }
        }
        .shop-info {
          margin-bottom: 20px;
          .avatar {
            float: left;
            width: 50px;
            height: 50px;
            border-radius: 2px;
            object-fit: cover;
          }
          .info {
            float: left;
            padding-left: 10px;
            p {
              font-size: 12px;
              line-height: 12px;
            }
            .shop-name {
              color: #333333;
              font-weight: bold;
              white-space: nowrap;
              margin-top: 6px;
              .el-tag {
                height: 17px;
                line-height: 15px;
                padding: 0 4px;
                margin-left: 8px;
              }
            }
            .shop-time {
              margin-top: 8px;
              color: #666666;
            }
          }
        }
        .marketing-info {
          padding: 18px 10px;
          background: #f8f8f8;
          margin-bottom: 26px;
          .el-link {
            font-size: 12px;
            vertical-align: inherit;
          }
          .info-tips {
            font-size: 12px;
            color: #999999;
          }
        }
        .fuc-info {
          .func-container {
            display: inline-block;
            width: 50%;
            margin-bottom: 15px;
            & > div {
              font-size: 14px;
              color: #333333;
              font-weight: bold;
              margin-bottom: 6px;
              .status {
                margin-right: 10px;
                vertical-align: middle;
              }
            }
          }
        }
      }
      .table-status {
        flex: 0.57;
        min-width: 620px;
        max-width: 790px;
        box-sizing: border-box;
        .table-list {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          margin-right: -20px;
          height: 154px;
          overflow: auto;
          &::-webkit-scrollbar {
            display: none;
          }
          .item {
            position: relative;
            width: 57px;
            min-width: 57px;
            height: 57px;
            margin-right: 20px;
            margin-bottom: 20px;
            line-height: 57px;
            text-align: center;
            font-size: 12px;
            color: #666666;
            box-sizing: border-box;
            border: 1px solid #e4e7ed;
            background: #f8f8f8;
            border-radius: 4px;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            &.occupy {
              background: #409eff;
              color: #fff;
              border-color: #409eff;
            }
            &.printed {
              background: #ffa51e;
              color: #fff;
              border-color: #ffa51e;
            }
            .btn {
              position: absolute;
              right: -1px;
              top: -1px;
              width: 32px;
              height: 18px;
              line-height: 18px;
              color: #fff;
              background: #a0cfff;
              text-align: center;
              border-top-right-radius: 4px;
              border-bottom-left-radius: 4px;
              display: none;
            }
            .queue-tag {
              position: absolute;
              right: -1px;
              bottom: -1px;
              width: 42px;
              height: 18px;
              line-height: 18px;
              color: #fff;
              background: #a0cfff;
              text-align: center;
              border-top-left-radius: 4px;
              border-bottom-right-radius: 4px;
            }
            &.occupy,
            &.printed {
              &:hover {
                .btn {
                  display: block;
                }
              }
            }
          }
        }
      }
    }
    .real-time-overview {
      .row {
        display: flex;
        margin-bottom: 14px;
        .item {
          // flex: 1;
          width: 25%;
          display: flex;
          padding-left: 20px;
          margin: 24px 0;
          cursor: default;
          box-sizing: border-box;
          .info {
            margin-left: 18px;
            .title {
              font-size: 12px;
              line-height: 12px;
              color: #666666;
              margin-top: 2px;
              margin-bottom: 12px;
              .el-link {
                margin-left: 10px;
                font-size: 12px;
                vertical-align: inherit;
              }
            }
            .num {
              font-size: 18px;
              line-height: 18px;
              color: #333333;
            }
          }
        }
      }
    }
    .vegetable-sales {
      .goods-list {
        display: flex;
        margin-right: -20px;
        .item {
          flex: 1;
          display: flex;
          padding: 20px;
          background: #f8f8f8;
          margin-right: 20px;
          max-width: 264px;
          border-radius: 4px;
          cursor: default;
          .pic {
            width: 50px;
            height: 50px;
            border-radius: 4px;
            object-fit: cover;
          }
          .info {
            margin-left: 10px;
            white-space: nowrap;
            .title {
              font-size: 14px;
              line-height: 14px;
              color: #333333;
              font-weight: bold;
              margin: 8px 0;
            }
            .num {
              font-size: 12px;
              line-height: 12px;
              color: #666666;
            }
          }
        }
      }
    }
    .common-func {
      padding-bottom: 10px;
      .icon {
        .iconfont {
          font-size: 18px;
        }
      }
      .list {
        display: flex;
        flex-wrap: wrap;
        .item {
          flex: 1;
          max-width: 216px;
          min-width: 130px;
          padding: 20px;
          border-radius: 4px;
          background: #f8f8f8;
          margin-right: 20px;
          margin-bottom: 10px;
          display: flex;
          cursor: pointer;
          .info {
            margin-left: 10px;
            .title {
              font-size: 14px;
              color: #333333;
              font-weight: bold;
              .num {
                color: #ff4343;
              }
            }
          }
        }
      }
    }
    .marketing-apply {
      .product-list {
        display: flex;
        .item {
          background: #f8f8f8;
          display: flex;
          width: 240px;
          height: 74px;
          border-radius: 2px;
          align-items: center;
          margin-right: 20px;
          cursor: pointer;
          transition: all 0.5s;
          padding-right: 20px;
          & > img {
            width: 44px;
            height: 44px;
            margin: 0 10px 0 20px;
          }
          .info {
            & > p {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 160px;
            }
            .title {
              font-size: 14px;
              line-height: 14px;
              color: #333333;
              margin-bottom: 12px;
              font-weight: bold;
            }
            .desc {
              font-size: 12px;
              line-height: 12px;
              color: #999999;
            }
          }
        }
      }
    }
  }
  .right-container {
    float: right;
    width: 240px;
    .content-container {
      white-space: nowrap;
      & > .icon {
        width: 34px;
      }
      & > .info {
        margin-left: 10px;
        display: inline-block;
        .title {
          font-size: 14px;
          color: #333333;
        }
        .desc {
          font-size: 12px;
          color: #666666;
        }
      }
    }
    .download {
      cursor: pointer;
      .info {
        margin-left: 20px;
      }
    }
    .message {
      .top {
        .title {
          font-size: 14px;
          line-height: 20px;
          color: #333333;
          font-weight: bold;
          .el-link {
            margin-left: 10px;
            vertical-align: inherit;
          }
        }
      }
      .content-container {
        margin-top: 8px;
      }
    }
  }
}
</style>

<style lang="less">
.top {
  .el-radio-group {
    margin-left: 20px;
    .el-radio {
      margin-right: 20px;
      .el-radio__label {
        padding-left: 6px;
      }
    }
  }
}
.table-status {
  .el-tabs__item.is-top {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.download-dialog {
  .el-dialog__body {
    padding: 30px;
    text-align: center;
    p {
      font-size: 18px;
      margin: 20px;
    }
  }
}
.verified-dialog {
  text-align: center;
  .icon {
    width: 55px;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #99cc00;
    line-height: 16px;
    margin-top: 20px;
  }
  .tips {
    font-size: 14px;
    line-height: 26px;
    margin-top: 12px;
    padding: 0 20px;
    color: #999999;
  }
  .close-tips {
    margin-top: 14px;
  }
  .dialog-footer {
    text-align: center;
    margin-top: 28px;
    margin-bottom: 10px;
  }
}
.content-container {
  .message-list {
    .item {
      .el-link {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
